module.exports = __webpack_public_path__ + "assets/img/w_d_i_9.31f8ae24.jpg";